import { TriageAlertState } from '~domain/entities/TriageAlertState';
import { UserRepository } from '~repositories/UserRepository';
import { UserStateResolverService } from '~services/UserStateResolverService';
import { diContainer } from '~setup/diContainer';
import serviceNames from '~setup/RampService';

export class TriageAlertDisplayedUseCase {
    private userRepository: UserRepository;
    private userStateResolver: UserStateResolverService;

    constructor() {
        this.userRepository = diContainer.get(serviceNames.userRepository);
        this.userStateResolver = new UserStateResolverService(
            this.userRepository.matchedExistingUsers
        );
    }

    public execute = () => {
        const { cacheUserProfileChanges, setTriageAlertState } = this.userRepository;
        // Profile in payload matches to any complete user, so the user is able to login
        const { isCompleteUserFound } = this.userStateResolver;
        const state = new TriageAlertState();
        state.visible = true;
        state.isCompleteUserFound = isCompleteUserFound;
        if (isCompleteUserFound) {
            cacheUserProfileChanges();
        }
        setTriageAlertState(state);
    };
}
